
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-architecture",
      function () {
        return require("private-next-pages/content-architecture.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-architecture"])
      });
    }
  